import { render, staticRenderFns } from "./SliderWithCta.vue?vue&type=template&id=491dd621&scoped=true&name=slider-with-cta&"
import script from "./SliderWithCta.vue?vue&type=script&lang=js&"
export * from "./SliderWithCta.vue?vue&type=script&lang=js&"
import style0 from "./SliderWithCta.vue?vue&type=style&index=0&id=491dd621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491dd621",
  null
  
)

export default component.exports